import * as actionTypes from "../actionTypes";
import axios from "axios";
import { config } from "../../../config/config";

const fetchRedeemsStart = () => {
  return {
    type: actionTypes.FETCH_REDEEMS_START,
  };
};

const fetchRedeemsSuccess = (redeems, total) => {
  return {
    redeems,
    total,
    type: actionTypes.FETCH_REDEEMS_SUCCESS,
  };
};

const fetchRedeemsFailed = (err) => {
  return {
    err,
    type: actionTypes.FETCH_REDEEMS_FAILED,
  };
};

export const onFetchRedeems = (page, limit) => {
  return async (dispatch) => {
    await dispatch(fetchRedeemsStart());
    try {
      const redeems = await axios.get(
        `${config.redeem}?limit=${limit}&page=${page + 1}&sort=-id`
      );

      await dispatch(
        fetchRedeemsSuccess(
          redeems.data.data,
          redeems.headers["x-total-count"]
        )
      );
    } catch (e) {
      await dispatch(fetchRedeemsFailed(e));
    }
  };
};

// FILTER
const filterRedeemsStart = () => {
  return {
    type: actionTypes.FILTER_REDEEMS_START,
  };
};

const filterRedeemsSuccess = (filtered, total) => {
  return {
    filtered,
    total,
    type: actionTypes.FILTER_REDEEMS_SUCCESS,
  };
};

const filterRedeemsFailed = (err) => {
  return {
    err,
    type: actionTypes.FILTER_REDEEMS_FAILED,
  };
};

export const onFilterRedeems = (params, page, limit) => {
  return async (dispatch) => {
    await dispatch(filterRedeemsStart());
    try {
      let url = `${config.redeem}/${params}?limit=${limit}&page=${page + 1}&sort=-id`;

      const filtered = await axios.get(url);
      await dispatch(
        filterRedeemsSuccess(filtered.data.data, filtered.headers["x-total-count"])
      );
    } catch (e) {
      await dispatch(filterRedeemsFailed());
    }
  };
};
